const s = (t) => `custom-tabs-input-${t}`;
export {
  s as getCustomTabsInputId
};
